import { ImportExport } from "@mui/icons-material";
import { ContentCopy, Delete } from "@mui/icons-material";
import React, { memo } from "react";

import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

const operatorLabel = (value) => {
  switch (Number(value)) {
    case 1:
      return "==";
    case 2:
      return ">=";
    case 3:
      return "<=";
    case 4:
      return "<";
    case 5:
      return ">";
    default:
      return "?";
  }
};

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  // Suporta o formato novo (rules + combinator) e o legado (key/condition/value)
  const rules =
    Array.isArray(data.rules) && data.rules.length > 0
      ? data.rules
      : data.key !== undefined
      ? [{ key: data.key, condition: data.condition, value: data.value }]
      : [];
  const combinator = (data.combinator || "AND").toString().toUpperCase();

  return (
    <div
      style={{
        backgroundColor: "#555",
        padding: "8px",
        borderRadius: "8px",
        minWidth: 180,
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{ background: "#0000FF" }}
        isConnectable={isConnectable}
      />
      <div
        style={{
          display: "flex",
          position: "absolute",
          right: 5,
          top: 5,
          cursor: "pointer",
          gap: 6,
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: "12px", height: "12px", color: "#ededed" }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: "12px", height: "12px", color: "#ededed" }}
        />
      </div>
      <div
        style={{
          color: "#ededed",
          fontSize: "16px",
          flexDirection: "row",
          display: "flex",
        }}
      >
        <ImportExport
          sx={{
            width: "16px",
            height: "16px",
            marginRight: "4px",
            marginTop: "4px",
          }}
        />
        <div style={{ color: "#ededed", fontSize: "16px" }}>Condição</div>
      </div>

      {rules.length > 1 && (
        <div style={{ color: "#F7953B", fontSize: "11px", marginTop: 2 }}>
          {combinator === "OR" ? "Qualquer (OU)" : "Todas (E)"}
        </div>
      )}

      <div style={{ marginTop: 4 }}>
        {rules.map((rule, index) => (
          <div
            key={index}
            style={{ color: "#ededed", fontSize: "12px", marginBottom: 2 }}
          >
            {rule.key} {operatorLabel(rule.condition)} {rule.value}
          </div>
        ))}
      </div>

      <div style={{ color: "#8fdf8f", fontSize: "11px", marginTop: 6 }}>
        Verdadeiro
      </div>
      <Handle
        type="source"
        position="right"
        id="a"
        style={{ top: "72%", background: "#3ABA38" }}
        isConnectable={isConnectable}
      />
      <div style={{ color: "#df8f8f", fontSize: "11px" }}>Falso</div>
      <Handle
        type="source"
        position="right"
        id="b"
        style={{ bottom: 8, top: "auto", background: "#EC5858" }}
        isConnectable={isConnectable}
      />
    </div>
  );
});
